import { render, staticRenderFns } from "./IdeaItem.vue?vue&type=template&id=342f51f6&scoped=true&lang=pug&"
import script from "./IdeaItem.vue?vue&type=script&lang=js&"
export * from "./IdeaItem.vue?vue&type=script&lang=js&"
import style0 from "./IdeaItem.vue?vue&type=style&index=0&id=342f51f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f51f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VLayout,VRow})
